<template>
  <div>
    <Autocomplete
      ref="autocomplete"
      :key="UserSearchKey"
      :search="searchUsers"
      :get-result-value="searchResult"
      @submit="handleSearchSubmit"
      placeholder="Start typing user's name or login (* for all)"
      defaultValue
      auto-select
      :debounce-time="300"
    >
      <template #result="{ result, props }">
        <li v-bind="props">
          <div class="wiki-title text-left">
            {{ searchResult(result) }}
          </div>
        </li>
      </template>
    </Autocomplete>
  </div>
</template>


<script>
import Autocomplete from "@trevoreyre/autocomplete-vue";
import "@trevoreyre/autocomplete-vue/dist/style.css";

export default {
  components: {
    Autocomplete,
  },

  props: {
    dataRetrievalFunction: {
      Required: true,
      type: Function,
    },
    displayResultsFunction: {
      Required: false,
      type: Function,
      default (result) {
        return result.first_name + " " + result.last_name + " \n" + result.login;
      }
    },
    submitFunction: {
      Required: false,
      type: Function,
      default: (result) => {
        console.log("UIComponent::UserSearch::Item Selected: " + result)
        this.$emit('submit', result)
      }
    },
  },

  data() {
    return {
      availableUsers: [],
      UserSearchKey: 0,
      UserWasDeleted: false,
    };
  },

  methods: {
    searchUsers(input) {
      return new Promise(resolve => {
        if (input.length < 1) {
          return resolve([])
        }
        this.availableUsers = this.dataRetrievalFunction(input).then(data =>{if(data && data.result){ resolve(data.result)}
        else { return resolve([])} });
      })
    },
    searchResult(result) {
      return this.displayResultsFunction(result)
    },
    handleSearchSubmit(result) {
      this.submitFunction(result);
      this.$refs.autocomplete.value = "";
    },
  },

  created() {
  },
};
</script>

<style scoped>
li {
  white-space: pre;
}
</style>